import { useStore } from 'vuex'
import { computed, ref, onBeforeMount } from 'vue'

import FormInputTextField from "../FormInputTextField/FormInputTextField";
import textAreaValidator from "foundation/js/inputValidators/textAreaValidator";
import nonEmptyStringValidator from "foundation/js/inputValidators/nonEmptyStringValidator";

export default {
    name: "CreateFolderOverlay",
    components: {
        FormInputTextField
    },

    setup(){
        const store = useStore()
        const overlayMode = computed(()=> store.state.frivillige.active_overlay_mode)
        const editModeActive = computed(()=> store.state.frivillige.edit_mode_active)
        
        let itemName = ref('')

        const isSubmitting = computed(()=> store.state.frivillige.is_submitting)
        let displayError = ref(false)

        onBeforeMount(() => {
            if (editModeActive.value) {
                itemName.value = store.state.frivillige.active_item_name
            }

            // the active overlay mode should be set when overlay activated as well as editModeActive
            // and creating updated active_name
            // store.dispatch('frivillige/getActiveItemName')
            // when overlay closed, mode is cleared inside PageOverlay.options closeOverlay
            // if in component library to debug activate a mode to see labels
                // to debug folder: store.dispatch('frivillige/setActiveOverlayMode', { mode: "Mappe"})          
                // to debug file: store.dispatch('frivillige/setActiveOverlayMode', { mode: "Dokument" })          
        })

        const isFormValid = () => {
            return textAreaValidator(itemName.value) 
                && nonEmptyStringValidator(itemName.value)
        };

        const submitCreateOrEditFolderOrFile = () => {
            const isValid = isFormValid();
            displayError.value = !isValid;

            if (isValid) {
                store.dispatch("frivillige/submitCreateOrEditFolderOrFile", {
                    name: itemName.value
                })
                .then(() => {
                    store.dispatch('main/closePageOverlay')
                    store.dispatch('search/refreshSearches')
                });
            }
        };

        const getLabel = (labelKey) => {

            if(editModeActive.value && overlayMode.value === 'Dokument') {
                return store.getters["labels/getLabel"]({
                        labelCollection: "EditFileOverlay",
                        labelKey: labelKey,
                    });
                
            } else if(overlayMode.value === 'Dokument') {
                return    store.getters["labels/getLabel"]({
                        labelCollection: "CreateFileOverlay",
                        labelKey: labelKey,
                    });
            } 
            else if(editModeActive.value && overlayMode.value === 'Mappe') {
                return    store.getters["labels/getLabel"]({
                        labelCollection: "EditFolderOverlay",
                        labelKey: labelKey,
                    });
                
            } 
            else if (overlayMode.value === 'Mappe') {
                return    store.getters["labels/getLabel"]({
                        labelCollection: "CreateFolderOverlay",
                        labelKey: labelKey,
                    });
            }

        }
        
        return {
            itemName,
            isSubmitting,
            displayError,
            submitCreateOrEditFolderOrFile,
            nonEmptyStringValidator,
            getLabel
        }
        
    }
}